import React from "react";
import ParallexPartical from "../../utils/ParallexPartical";
import Header from "../layouts/Header/Header";
import Footer from "../layouts/Footer";
import Custombutton from "../../utils/Custombutton";
import Countdowntimer from "../../utils/Countdowntimer";

const NebulaLight = () => {

  return (
    <>
      <div className="hero heros dvpn nodes">
        <div className=" h-100  position-relative  px-3 py-3 px-xxl-4 py-xxl-4">
          <Header />
          <div className="h-100 d-flex align-items-center jsutify-content-center">
            <div className="container  ">
              <div className="row ">
                <div className="col-lg-6">
                  <img
                    className="w-100 "
                    src="/assets/images/Quater.png"
                    alt="nebula"
                  />
                </div>
                <div className="col-lg-6">
                  <img
                    className="w-100 mb-4"
                    src="/assets/images/NebulaLighttxt1.png"
                    alt="NebulaLight "
                    style={{ marginLeft: "-18px" }}
                  />
                  <p className="mb-4">
                    Cosmic runs on a decentralized network of Nodes. Install our
                    PC package to operate a Node and earn passive income through
                    our reward program.
                  </p>
                  {/* <Custombutton className={"btn-bg w-100 p-4"}   label={"buy"} /> */}
                  <p className="fw-bold mt-3 fs-3 text-white">Sale Live in</p>
                  <Countdowntimer/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row spacing align-items-center">
            <div className="col-lg-6 mb-4 order-2 order-lg-1">
              <img
                className="w-100"
                src="/assets/images/Render_02.png"
                alt="Feature-1"
              />
            </div>
            <div className="col-lg-6 mb-4 order-1 order-lg-2">
              <h4>Features 1</h4>
              <p>
                Cosmic runs on a decentralized network of Nodes. Install our PC
                package to operate a Node and earn passive income through our
                rewards program.
              </p>
            </div>
          </div>
          <div className="row spacing align-items-center">
            <div className="col-lg-6 mb-4">
              <h4>Features 1</h4>
              <p>
                Cosmic runs on a decentralized network of Nodes. Install our PC
                package to o2perate a Node and earn passive income through our
                rewards program.
              </p>
            </div>
            <div className="col-lg-6 mb-4">
              <img
                className="w-100"
                src="/assets/images/Router_04.png"
                alt="Feature-1"
              />
            </div>
          </div>
          <div className="row  ">
            <div className="col-lg-12">
              <h4
                style={{
                  fontWeight: "400",
                  fontStyle: "normal",
                }}
                className="text-center"
              >
                Technical Specifications
              </h4>
              <img
                className="w-100"
                src="/assets/images/specifications.png"
                alt="specifications"
              />
            </div>
          </div>
          <div className="row spacing">
            <div className="col-lg-12">
              <img
                className="w-100"
                src="/assets/images/layeredrouter.png"
                alt="layeredrouter"
              />
            </div>
          </div>
          <div className="row spacing justify-content-center">
            <div className="col-lg-6 text-center">
              <h4 style={{ fontStyle: "normal" }}>Order Yours TOday</h4>
              <p>Private . Secure . Decentralized</p>
              <Custombutton className={"btn-bg w-100   mt-4"} label={"buy"} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default NebulaLight;
